// extracted by mini-css-extract-plugin
module.exports = {"header":"List_header__9hFMf","searchAndActions":"List_searchAndActions__1C06z"};